import { api } from './api';

export interface ZoneTemplate {
  template_id: string;
  org_id?: string;
  site_id?: string;
  name: string;
  description?: string | null;
  zone_type?: string | null;
  color?: string | null;
  bbox_norm?: number[] | null;
  polygon_norm?: number[][] | null;
  defaults?: Record<string, any>;
  created_at?: string;
  updated_at?: string;
}

export interface ZoneTemplateCreateInput {
  template_id?: string;
  name: string;
  description?: string;
  zone_type?: string;
  color?: string;
  bbox_norm?: number[] | null;
  polygon_norm?: number[][] | null;
  defaults?: Record<string, any>;
}

export const zoneTemplatesApi = {
  async list(siteId: string): Promise<ZoneTemplate[]> {
    const resp = await api.get('/api/v1/zone-templates', { params: { site_id: siteId } });
    return resp.data?.items || [];
  },

  async create(siteId: string, input: ZoneTemplateCreateInput): Promise<{ template_id: string }> {
    const resp = await api.post('/api/v1/zone-templates', input, { params: { site_id: siteId } });
    return resp.data;
  },

  async delete(siteId: string, templateId: string): Promise<void> {
    await api.delete(`/api/v1/zone-templates/${encodeURIComponent(templateId)}`, { params: { site_id: siteId } });
  },
};

